import React from "react";
import { Box, Typography } from "@mui/material";
import { BulkMarkLegend } from "./BulkMarkLegend";

/** グリッド直上の1行。印の凡例と操作案内を並べる */
export const BulkLegendBar: React.FC = () => (
  // 操作の案内は凡例と離すと目に入らないため隣に並べる
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 3,
      mb: 1,
    }}
  >
    {/* 凡例は枠で囲って「説明」だと分かるようにする */}
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 1.5,
        py: 0.5,
        border: 1,
        borderColor: "divider",
        borderRadius: 1,
        bgcolor: "action.hover",
      }}
    >
      <Typography variant="body2" color="text.secondary">
        凡例
      </Typography>
      <BulkMarkLegend />
    </Box>
    <Typography variant="body2" color="text.secondary">
      列名をダブルクリックすると表示中の行を列ごとに一括ON/OFFできます
    </Typography>
  </Box>
);
